if (window.jQuery){
    (function($){
        $.fn.visible = function(partial){

            var $t        = $(this),
                $w        = $(window),
                viewTop     = $w.scrollTop(),
                viewBottom    = viewTop + $w.height(),
                _top      = $t.offset().top,
                _bottom     = _top + $t.height(),
                compareTop    = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

    })(jQuery);

    window.jQuery(function ($) {


        $(document).scroll(function() {
            var y = $(this).scrollTop();
            if($('#wpadminbar').length){
                $('nav#sticky-genre').addClass('admin');
            }

            if($('body.home').length > 0){
                if($('#sticky-genre').length > 0) {
                    var searchBar = $('#newSpotlightSearch');
                    if($(window).scrollTop() > (searchBar.height()+150)) {

                        $('.stickywrapper').slideDown();
                    }else{
                        $('.stickywrapper').slideUp();
                    }
                }
            }


        });


        if ($(window).width() < 451){
            if($('a.onlyOnMobileMenu').length > 0){
                $('a.onlyOnMobileMenu').attr("onclick", "trackCTA( 'top_bar_clicked', 'mobile menu was opened from logo' )");
            }
        }


    });


}
